import { Field } from 'formik'
import SkeletonLoader from '@/Layout/SkeletonLoader'

const FormikInput = (props) => {
    const { inputProps, customClass, skeletonLoading } = props

    return (
        <>
            {skeletonLoading ? <SkeletonLoader height={54} rows={1} /> :
                <Field {...inputProps} className={`${customClass} appearance-none border border-neutral-200 bg-white rounded-2xl w-full py-3 px-4 text-sm font-medium text-neutral-900 placeholder:text-neutral-400 placeholder:font-normal focus:outline-none focus:border-primary/60 focus:ring-4 focus:ring-primary/15 focus-visible:outline-none transition-all duration-150`}>
                </Field>
            }
        </>
    )
}

export default FormikInput
